import { Navigate } from 'react-router';

import { EscrowStatusEnum, type ISoftwareEscrow, type IContinuityEscrow, type ISaasEscrow } from 'src/graphql/schema';
import { shouldCurrentPartyConfigureEscrow } from 'src/utils/escrow';

type IEscrow = ISoftwareEscrow | IContinuityEscrow | ISaasEscrow;

type IUseOnboardingGuard<TStep extends string> = {
  escrow: IEscrow;
  basePath: string;
  getStep: (id: string) => TStep | null;
  setStep: (id: string, step: 'members') => void;
  removeStep: (id: string) => void;
};

export function useOnboardingGuard<TStep extends string>({
  escrow,
  basePath,
  getStep,
  setStep,
  removeStep,
}: IUseOnboardingGuard<TStep>): React.ReactElement | null {
  const isSetupRequired = shouldCurrentPartyConfigureEscrow(escrow);
  const onboardingStep = getStep(escrow.id);
  const isOnboarding = escrow.status === EscrowStatusEnum.Onboarding;

  if (Boolean(onboardingStep) && !isOnboarding) {
    removeStep(escrow.id);
    return null;
  }

  if (isSetupRequired || Boolean(onboardingStep)) {
    if (!onboardingStep) setStep(escrow.id, 'members');

    return <Navigate to={`${basePath}/${escrow.id}`} replace />;
  }

  return null;
}
